import LiveSplitView from './src/main';

LiveSplitView.install = function (Vue) {
  Vue.component(LiveSplitView.name, LiveSplitView);
};

export default LiveSplitView;
